/**
 * @license @lucide/lab v0.1.2 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const centCircle = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 6v12", key: "1vza4d" }],
  ["path", { d: "M16 9a5 5 0 1 0 0 6", key: "1xum1f" }]
];

export { centCircle as default };
//# sourceMappingURL=cent-circle.js.map
